import * as React from 'react'
import Dlg from './Dlg'
import InputField from './InputField'

import { Typography, InputLabel, MenuItem, FormControl } from '@mui/material'
import { type MouseEventHandler } from 'react'
import Select from '@mui/material/Select'
import { styled } from '@mui/material/styles'

interface CancelAccountPlanDlgProps {
  reasons: Array<{ label: string, value: number }>
  open: boolean
  handleClose: MouseEventHandler<HTMLButtonElement>
  handleMode: any
  cancelPlanReason: any
  setCancelPlanReason: any
  handleTypeChange: any
  serviceName: string
  category: string
}

const Label = styled(InputLabel)(({ theme }) => ({
  color: '#6B7A99',
  fontSize: 14,
  fontWeight: 700,
  marginBottom: '13px'
}))

const CancelAccountPlanDlg: React.FC<CancelAccountPlanDlgProps> = ({ reasons, open, handleClose, handleMode, cancelPlanReason, setCancelPlanReason, handleTypeChange, serviceName, category }) => {
  return (
    <Dlg name='Cancel Plan' open={open} handleClose={handleClose} okBtnText={'Continue'} showBtn={false} handleSubmit={handleMode} disabled={cancelPlanReason === ''} >
      <>
      <Typography variant='subtitle2' sx={{ my: 4 }}>
        Please tell us a little about why you want to discontinue these {serviceName}
      </Typography>
      <Label htmlFor='reason-select'>Choose a Reason</Label>
      <FormControl fullWidth>
          <InputLabel id='reason-select' sx={{ ml: '20px', color: '#7D8FB3' }}>Choose a Reason</InputLabel>
          <Select
            labelId='reason-select'
            label='Choose a Reason'
            id='reason-select'
            value={cancelPlanReason}
            fullWidth
            onChange={handleTypeChange}
            sx={{ mb: 3 }}
          >
            {reasons.map(({ value, label }, index) => (
              <MenuItem key={index} value={value}
              sx={{ fontSize: 14, fontWeight: 700 }}>
              {label}
              </MenuItem>
            ))}
          </Select>
      </FormControl>
      <Label htmlFor='explain-reason'>If other, please explain</Label>
      <InputField
        id='explain-reason'
        multiline
        rows={4}
        maxRows={4}
        fullWidth
        sx={{ mb: 3 }}
      />
      </>
    </Dlg>
  )
}

export default CancelAccountPlanDlg
